import { TabTagType } from "#resources/helpers/tabs";
import classNames from "classnames";
import * as React from "react";
import s from "./icon.module.scss";
import { ICON_NAMES } from "./constants";

interface Props extends React.SVGProps<SVGElement> {
	icon: IconName;
	className?: string;
	style?: React.CSSProperties;
	tagType?: TabTagType;
	rotate?: number;
}

export type IconName = typeof ICON_NAMES[number];

// debito técnico: move this to svgr and get icon types by icons file name

const MAX_ROTATE = 360;

// Cache dos componentes lazy por nome de ícone. Sem isso, um novo componente
// lazy era criado a cada render, forçando remount + fallback do Suspense e
// causando flicker dos ícones a cada re-render (navegação, sidebar, cliques).
const svgComponentCache: Record<
	string,
	React.LazyExoticComponent<React.ComponentType<any>>
> = {};

function getSvgComponent(icon: string) {
	if (!svgComponentCache[icon]) {
		svgComponentCache[icon] = React.lazy(() => import(`./imgs/${icon}.svg`));
	}
	return svgComponentCache[icon];
}

const Icon = ({ className, icon, tagType, rotate, ...svgProps }: Props) => {
	const SvgComponent = getSvgComponent(icon);

	const rotationStyle =
		rotate && rotate <= MAX_ROTATE ? { transform: `rotate(${rotate}deg)` } : {};

	return (
		<React.Suspense fallback="-">
			<div className={classNames(s.icon, className)}>
				<SvgComponent data-icon={icon} style={rotationStyle} {...svgProps} />

				{tagType && (
					<div
						className={classNames({
							[s.notification]: true,
							[s.new]: tagType === "new",
							[s.comingSoon]: tagType === "comingSoon",
						})}
					/>
				)}
			</div>
		</React.Suspense>
	);
};

export default Icon;
